<template>
  <div class="custom-list-container">
    <div class="pricing-cards">
      <!-- 轻奢级版 -->
      <TransitionGroup name="card-stagger" appear>
        <div
          v-for="(item, index) in customList"
          :key="item.type"
          class="pricing-card"
          :style="{ '--delay': `${index * 0.1}s` }"
        >
          <div class="card-header">
            <div class="icon-container">
              <img :src="item.icon" alt="custom-icon" class="custom-icon w-[50px] h-[56px]" />
            </div>
            <h3 class="plan-title">{{ item.name }}</h3>
          </div>
          <div class="price-section">
            <div class="current-price">
              <span class="text-size12 text-[#000000]">￥</span>
              <span class="text-[19px] font-[700] text-[#000000]">{{ item.price }}</span>
            </div>
            <div v-if="item.originalPrice > 0" class="text-size12 text-[#8E8E93]">
              /原价{{ item.originalPrice }}
            </div>
          </div>
          <div class="features">
            <div v-for="feature in item.features" :key="feature" class="feature-item">
              <!-- <div class="checkmark">✓</div> -->
              <img src="@/assets/icon/select.png" alt="bg" class="w-[18px] h-[18px] mr-[6px]" />
              <span>{{ feature }}</span>
            </div>
          </div>
          <button
            class="order-btn"
            :class="
              item.products[0].product === CustomType.CUSTOM_LITE
                ? 'light-btn'
                : item.products[0].product === CustomType.CUSTOM_HQ
                  ? 'high-btn'
                  : item.products[0].product === CustomType.CUSTOM_MASTER
                    ? 'master-btn'
                    : 'cinema-btn'
            "
            @click.stop="handleOrder(item)"
          >
            立即订购
          </button>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CustomType } from '@/config/constants'

const emit = defineEmits(['handleOrder'])

defineProps<{
  customList: any[]
}>()

const handleOrder = (plan: any) => {
  emit('handleOrder', plan)
}
</script>

<style scoped>
.custom-list-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 37px;
}

.pricing-cards {
  flex: 1;
  gap: 13px;
  display: flex;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pricing-card {
  flex: 1;
  background: white;
  border-radius: 6px;
  padding: 12px 12px 19px 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transform: translateY(0);
  opacity: 1;
}

.pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.pricing-card.selected {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border: 2px solid #007aff;
}

.card-header {
  text-align: center;
  margin-bottom: 14px;
}

.icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.crown-icon {
  width: 60px;
  height: 60px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.light-crown {
  background: #f5f5f5;
  border-color: #ccc;
}

.high-crown {
  background: #e3f2fd;
  border-color: #2196f3;
}

.master-crown {
  background: #f3e5f5;
  border-color: #9c27b0;
}

.cinema-crown {
  background: #fff3e0;
  border-color: #ff9800;
}

.music-note {
  font-size: 24px;
  color: #666;
  font-weight: bold;
}

.plan-title {
  font-size: 14px;
  font-weight: 500;
  color: #3d3d3d;
  margin: 0;
}

.price-section {
  text-align: center;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.features {
  margin-bottom: 24px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
  color: #999;
}

.checkmark {
  width: 20px;
  height: 20px;
  background: var(--theme-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
}

.order-btn {
  width: 100%;
  padding: 12px 24px;
  border: none;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.light-btn {
  background: white;
  color: #000000;
  border: 1px solid #ddd;
}

.high-btn {
  background: #98b0d7;
  color: white;
}

.master-btn {
  background: linear-gradient(90deg, #6c37a1 0%, #58277f 100%), #98b0d7;
  color: white;
}

.cinema-btn {
  background:
    linear-gradient(90deg, #3d2710 0%, #28160a 100%),
    linear-gradient(90deg, #6c37a1 0%, #58277f 100%);
  color: white;
}

.order-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* 卡片进入动画 */
.card-stagger-enter-active {
  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  transition-delay: var(--delay, 0s);
}

.card-stagger-enter-from {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
  filter: blur(2px);
}

.card-stagger-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

/* 卡片悬停效果增强 */
.pricing-card {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.6s ease;
  }

  &:hover::before {
    left: 100%;
  }
}

/* 按钮动画增强 */
.order-btn {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition:
      width 0.6s ease,
      height 0.6s ease;
  }

  &:active::before {
    width: 300px;
    height: 300px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .pricing-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .pricing-card {
    padding: 20px;
  }

  .current-price {
    font-size: 28px;
  }
}
</style>
